import { Controller } from '@hotwired/stimulus'
import { addClass, removeClass } from 'utils/toggle_class'

export default class extends Controller {
  static targets = ["menu", "menuButton", "menuItem", "submenu"]

  initialize() {
    this.DELAY_FOR_HOVER = 500
  }

  toggleMenu(event) {
    if (this.element.classList.contains("-open")) {
      this._closeMenu(event)
    } else {
      this._openMenu(event)
    }
  }

  openMenuOnDesktop(event) {
    // Prevents issues on touch-screen devices & only allow mouseover on fullscreen
    if (event.pointerType === "mouse" && window.matchMedia("(min-width: 1200px)").matches) {
      this._openMenu(event)
    }
  }

  globalCloseMenu(event) {
    this._closeMenu(event)
  }

  delayedCloseMenu(event) {
    // Prevents mouseout unless fullscreen
    if (window.matchMedia("(max-width: 1199px)").matches) { return }

    // Delay closing by 0.5 seconds. If the user moves the mouse
    // back into the menu during that time, don't close
    setTimeout(() => {
      if (this.element.matches(':hover') || this.menuTarget.matches(':hover')) { return }

      this._closeMenu(event)
    }, this.DELAY_FOR_HOVER)
  }

  openSubmenuOnDesktop(event) {
    // Prevents issues on touch-screen devices & only allow mouseover on fullscreen
    if (event.pointerType === "mouse" && window.matchMedia("(min-width: 1200px)").matches) {
      this._openSubmenu(event)
    }
  }

  toggleSubmenu(event) {
    const menuItem = this._menuItemForEvent(event)

    if (menuItem.classList.contains("-open")) {
      this._closeSubmenu(event)
    } else {
      this._openSubmenu(event)
    }
  }

  delayedCloseSubmenu(event) {
    // Prevents mouseout unless fullscreen
    if (window.matchMedia("(max-width: 1199px)").matches) { return }

    const menuItem = this._menuItemForEvent(event)
    const submenu = menuItem.querySelector('[data-topnav-menu-target="submenu"]')

    // Delay closing by 0.5 seconds. If the user moves the mouse
    // back into the submenu during that time, don't close
    setTimeout(() => {
      if (menuItem.matches(':hover') || submenu.matches(':hover')) { return }

      this._closeSubmenu(event)
    }, this.DELAY_FOR_HOVER)
  }

  closeOnClickOutside(event) {
    if (this.element.contains(event.target)) return

    this._closeMenu()
  }

  /// Private ///
  _collapseAllSubmenus() {
    removeClass(this.menuItemTargets, "-open")
  }

  _menuItemForEvent(event) {
    const menuButton = event.target
    return menuButton.closest('[data-topnav-menu-target="menuItem"]')
  }

  _openMenu(_event) {
    document.dispatchEvent(new CustomEvent("topnav.globalCloseMenu"))
    addClass(this.element, "-open")
    this.menuButtonTarget.setAttribute("aria-expanded", true)
  }

  _closeMenu(_event) {
    removeClass(this.element, "-open")
    this.menuButtonTarget.setAttribute("aria-expanded", false)

    this._collapseAllSubmenus()
  }

  _openSubmenu(event) {
    if (this._submenuTouchDelay) { return }

    const menuItem = this._menuItemForEvent(event)

    this._collapseAllSubmenus()
    addClass(menuItem, "-open")
    menuItem.setAttribute("aria-expanded", true)
  }

  _closeSubmenu(event) {
    const menuItem = this._menuItemForEvent(event)

    removeClass(menuItem, "-open")
    menuItem.setAttribute("aria-expanded", false)
  }
}
